import axios from "axios";

export default {
  obtenerIp: function(handler) {
    axios.get("https://api.ipify.org?format=json").then(handler);
  }
};
